import { useBrandingContext } from 'app-context/BrandingsContext';
import Modal from 'component/hoc/modal/Modal';
import React, { useEffect, useState } from 'react';
import styles from './DatePicker.module.scss';
import moment from 'moment';

function DatePicker({
  showDateModal,
  setShowDateModal,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  handleSubmitDatePicker,
}) {
  const { brandingData } = useBrandingContext();

  const ISO_UTC_FMT = 'YYYY-MM-DD[T]HH:mm:ss[Z]';
  const toYYYYMMDD = (v) => {
    if (!v) return '';
    if (v instanceof Date) return moment(v).format('YYYY-MM-DD');
    if (moment.isMoment(v)) return v.format('YYYY-MM-DD');
    const m = moment(v);
    return m.isValid() ? m.format('YYYY-MM-DD') : '';
  };

  const defaultStart = moment().subtract(6, 'days').format('YYYY-MM-DD');
  const defaultEnd = moment().format('YYYY-MM-DD');

  const [tempStartDate, setTempStartDate] = useState(
    toYYYYMMDD(startDate) || defaultStart
  );
  const [tempEndDate, setTempEndDate] = useState(
    toYYYYMMDD(endDate) || defaultEnd
  );
  const [error, setError] = useState('');

  useEffect(() => {
    if (showDateModal) {
      setTempStartDate(toYYYYMMDD(startDate) || defaultStart);
      setTempEndDate(toYYYYMMDD(endDate) || defaultEnd);
      setError('');
    }
  }, [showDateModal, startDate, endDate]);

  const handleSubmit = () => {
    if (!tempStartDate || !tempEndDate) {
      setError('Both dates are required.');
      return;
    }
    if (moment(tempStartDate).isAfter(moment(tempEndDate))) {
      setError('Invalid date range: Start date cannot be after end date.');
      return;
    }

    const startUtc = moment(tempStartDate, 'YYYY-MM-DD')
      .startOf('day')
      .utc()
      .format(ISO_UTC_FMT);

    const endUtc = moment(tempEndDate, 'YYYY-MM-DD')
      .endOf('day')
      .utc()
      .format(ISO_UTC_FMT);

    setStartDate(startUtc);
    setEndDate(endUtc);

    if (handleSubmitDatePicker) {
      handleSubmitDatePicker(tempStartDate, tempEndDate);
    }
    setShowDateModal(false);
  };

  const today = moment().format('YYYY-MM-DD');

  return (
    <Modal
      title='Custom Date'
      isOpen={showDateModal}
      onClose={() => setShowDateModal(false)}
      buttonType='submit'
      onSubmit={handleSubmit}
      modalContent={{
        component: (
          <div className={styles['dates-container']}>
            <div className={styles['date-input-container']}>
              <label
                htmlFor='startDate'
                style={{ color: brandingData?.page_TextColor }}
              >
                From
              </label>
              <input
                id='startDate'
                type='date'
                value={tempStartDate}
                onChange={(e) => {
                  setTempStartDate(e.target.value);
                  if (error) setError('');
                }}
                style={{ color: brandingData?.page_TextColor }}
                max={tempEndDate || today}
              />
            </div>

            <div className={styles['date-input-container']}>
              <label
                htmlFor='endDate'
                style={{ color: brandingData?.page_TextColor }}
              >
                To
              </label>
              <input
                id='endDate'
                type='date'
                value={tempEndDate}
                onChange={(e) => {
                  setTempEndDate(e.target.value);
                  if (error) setError('');
                }}
                style={{ color: brandingData?.page_TextColor }}
                min={tempStartDate}
                max={today}
              />
            </div>

            {error ? (
              <div style={{ marginTop: 8, fontSize: 12, color: '#e03131' }}>
                {error}
              </div>
            ) : null}
          </div>
        ),
      }}
    />
  );
}

export default DatePicker;
